export const blockIconsUiactionsArrowUpwardNew = (
	<span className='material-symbols-outlined'>arrow_upward</span>
);
